module.exports = __webpack_public_path__ + "img/error.42782fb8.svg";